export enum Action {
  created,
  updated,
  deleted
}

export function useNotificationHandlers() {
  const { NavigateSideways } = useNavigationClick();
  const calendarAPI = useCalendarAPI();

  function handleMessage(id: number, action: Action) {
    if (action == Action.created || action == Action.updated) {
      eventBus.emit('openMessagesModal', { messageID: id });
    }
  }

  function handleWorksheet(worksheetID: number, action: Action) {
    if (action === Action.created || action === Action.updated) {
      NavigateSideways('/worksheets/' + worksheetID, true, true);
    }
  }

  async function handleAppointment(id: number, action: Action) {
    if (action === Action.created || action === Action.updated) {
      const event = await calendarAPI.GetById(id);

      if (event && event.HasErrors === false) {
        NavigateSideways(`/calendar#event?id=${id}`, true, true);
      }
    }
  }

  return {
    handleMessage,
    handleWorksheet,
    handleAppointment
  };
}
